import React from 'react';

import Footer from '../../features/footer/Footer';
import HeaderWithActions from '../../features/Header/HeaderWithActions';
import StyledPageContent from './Page.styled';

const PageWithHalfHeader = ({ children }) => {
  return (
    <>
      <StyledPageContent>
        <HeaderWithActions hideNavMenu />
        <main>{children}</main>
      </StyledPageContent>

      <Footer />
    </>
  );
};

export default PageWithHalfHeader;
